<template>
  <open-modal
    @open-modal="openModal"
  />

  <teleport to="body">
    <modal
      v-if="isModalOpen"
      @keydown.esc="closeModal"
      @close-modal="closeModal"
    />
  </teleport>
</template>

<script>
/* Components */
import OpenModal from './OpenModal.vue';
import Modal from './Modal.vue';

export default {
  name: 'GlobalSearch',
  components: {
    OpenModal,
    Modal,
  },
  data() {
    return {
      isModalOpen: false,
    };
  },
  methods: {
    openModal() {
      this.isModalOpen = true;
      document.body.classList.add('no-scroll');
    },
    closeModal() {
      this.isModalOpen = false;
      document.body.classList.remove('no-scroll');
    }
  },
};
</script>
